export const formatPresenceDate = (value) => {
  if (!value) return "—";

  const parsedDate = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsedDate.getTime())) return "—";

  const year = parsedDate.getFullYear();
  const month = `${parsedDate.getMonth() + 1}`.padStart(2, "0");
  const day = `${parsedDate.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getPresenceKind = (presence) => {
  if (presence?.staff) return "personnel";
  if (presence?.student) return "eleve";
  return "autre";
};

export const getPresenceOwnerLabel = (presence) => {
  const staff = presence?.staff;
  if (staff) {
    const firstName = staff?.user?.first_name || "";
    const lastName = staff?.user?.last_name || "";
    const familyName = staff?.user?.family_name || "";
    const matricule = staff?.matricule ? `${staff.matricule} ` : "";
    return `${matricule}${lastName} ${familyName} ${firstName} `.trim() || "Personnel";
  }

  const student = presence?.student;
  const firstName = student?.user?.first_name || student?.first_name || "";
  const lastName = student?.user?.last_name || student?.last_name || "";
  const familyName = student?.user?.family_name || student?.last_name || "";
  const matricule = student?.matricule ? `${student.matricule} ` : "";

  return `${matricule}${lastName} ${ familyName } ${firstName}`.trim() || "Élève";
};

export const getPresenceClassLabel = (presence) => {
  const student = presence?.student;
  const sectionclass = student?.sectionclass || student?.sectionclasse || {};
  const className = sectionclass?.class?.short_entitled_class || sectionclass?.class?.entitled_class || "";
  const title = sectionclass?.title || "";
  const sectionName = sectionclass?.section?.short_entitled_section || sectionclass?.section?.entitled_section || "";
  const parts = [className, title, sectionName].filter(Boolean);

  return parts.join(" ").trim() || "—";
};
